<script>
let BASE_URL = 'http://192.168.1.224:8080'
let VUE_URL='http://testktx.ifenghui.com/web/sharedetail/dist/index.html#'
let KTX_TOKEN_NAME='ktxToken'
if (process.env.NODE_ENV === 'production') {
//  BASE_URL = 'http://47.99.75.2:8082'
    BASE_URL = '//ktx.cn'
    VUE_URL='https://ktx.cn/webshare/?p=1#'
//}else if (process.env.NODE_ENV === 'beta') {
////  BASE_URL = 'http://47.99.75.2:8082'
//    BASE_URL = 'https://open3.vistastory.com/beta'
//    VUE_URL='https://open3.vistastory.com/web/webproject/sharedetail/index.html?p=1#'
} else if (process.env.NODE_ENV === 'development') {
//    BASE_URL = 'http://192.168.1.252:8080'
  BASE_URL = 'http://testktx.ifenghui.com'
    KTX_TOKEN_NAME='ktxToken_Dev'
//    BASE_URL = 'http://192.168.1.56:8080'
//  BASE_URL = 'http://open3.vistastory.com'
//  BASE_URL = 'http://192.168.1.198:8080'
//    VUE_URL='http://localhost:8081/index.html#'
} else if (process.env.NODE_ENV === 'testing') {
  BASE_URL = '//ktx.cn/test'
    VUE_URL='https://ktx.cn/test/webshare/?p=1#'
    KTX_TOKEN_NAME='ktxToken_Test'
}
window.BASE_URL = BASE_URL
window.VUE_URL=VUE_URL
// window.UEDITOR_CONFIG_APIURL=BASE_URL
export default{
  BASE_URL,VUE_URL,KTX_TOKEN_NAME
}
</script>



// WEBPACK FOOTER //
// src/Global.vue